import { RawLocation, Route } from "vue-router";

export const getTrailingSpaceRedirect = (route: Route): RawLocation | null => {
  const path = route.path.replace(/(?:%20| )+$/gi, "") || "/";
  if (path === route.path) return null;

  return {
    path,
    query: route.query,
    hash: route.hash,
    replace: true,
  };
};
